export default __webpack_public_path__ + "static/media/sobre.13f9606c.jpg";